<template>
  <v-card class="mx-auto text-center" color="#f1f1f1">
    <v-toolbar dense height="32px" flat color="grey lighten-2">
      <v-toolbar-title>Turnover / Month</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click="showChartOptions"></v-app-bar-nav-icon>
    </v-toolbar>

    <v-card-text>
      <canvas ref="myChart" width="100" height="70"></canvas>
    </v-card-text>

    <v-divider></v-divider>

    <!-- <v-card-actions class="justify-center">
      <v-btn block text>Go to Report</v-btn>
    </v-card-actions>-->

    <v-row justify="center">
      <v-dialog v-model="showDialog" scrollable max-width="380px">
        <DialogChart :info="obj" @save="save" @cancel="showDialog = false" />
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import Chart from "chart.js";
import moment from "moment";
import { storeprops } from "@/store/helpers.js";
import DialogChart from "@/components/dashboard/DialogChart";

export default {
  components: { DialogChart },
  data() {
    return {
      showDialog: false,
      obj: new ChartInfo(),
      createChart: undefined,
      refChart: undefined,
    };
  },
  computed: {
    ...storeprops,
  },
  methods: {
    // createChart() {
    //   doCreateChart();
    // },
    // getData() {
    //   let result = this.$store.getters.getDashboardInfo("turnover_month");
    //   return result;
    // },
    // getInvoiceByMonth() {
    //   let result = this.$store.getters.getInvoiceAmount(2, 2020);
    //   console.log("getInvoiceByMonth => " + result);
    //   return result;
    // },
    showChartOptions() {
      this.obj = new ChartInfo();
      this.showDialog = true;
    },
    save(info) {
      this.obj = info;
      this.refChart.destroy();
      let el = this.$refs.myChart;
      this.refChart = this.createChart(info);
    },
  },
  mounted() {
    let el = this.$refs.myChart;
    this.createChart = doCreateChart(el, this.$store);
    this.refChart = this.createChart(this.obj);
  },
};

const lastTwelveMonths = () => {
  const arr = [];
  // create a current start date of the 1st of this month
  const fistOfThisMonth = moment().set("date", 1);
  const startMonth = fistOfThisMonth.subtract(12, "months");
  for (let i = 0; i < 12; i++)
    arr.push(startMonth.add(1, "months").format("MMM"));
  return arr;
};

const getRandomTurnover = () => {
  return Math.floor(Math.random() * Math.floor(5000));
};

const getRandomTurnoverArr = () => {
  const arr = [];
  for (let i = 0; i < 12; i++) arr.push(getRandomTurnover());
  return arr;
};

const getData = (store) => {
  const arr = [];
  // create a current start date of the 1st of this month
  const fistOfThisMonth = moment().set("date", 1);
  const startMonth = fistOfThisMonth.subtract(12, "months");
  for (let i = 0; i < 12; i++) {
    let tempDay = startMonth.add(1, "months");
    let result = store.getters.getInvoiceAmount(tempDay);
    arr.push(result);
  }
  return arr;
};

class ChartInfo {
  graphType = "bar";
  time = "Last12Month";
  dataType = "turnover/month";
}

const doCreateChart = (el, store) => {
  return (info) => {
    return new Chart(el, {
      type: info.graphType.toLowerCase(),
      data: {
        labels: lastTwelveMonths(),
        datasets: [
          {
            data: getData(store),
            backgroundColor: "rgba(54, 162, 235, 1)",
            borderColor: "rgba(153, 102, 255, 1)",
            borderWidth: 1,
          },
        ],
      },
      options: {
        legend: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return "£" + value / 1000 + "k";
                },
              },
            },
          ],
        },
      },
    });
  };
};

// const doCreateChart = (el, info) => {
//   //var ctx = document.getElementById("myChart");
//   return new Chart(el, {
//     type: info.graphType.toLowerCase(),
//     data: {
//       labels: lastTwelveMonths(),
//       datasets: [
//         {
//           data: getData(),
//           backgroundColor: "rgba(54, 162, 235, 1)",
//           borderColor: "rgba(153, 102, 255, 1)",
//           borderWidth: 1
//         }
//       ]
//     },
//     options: {
//       legend: false,
//       scales: {
//         yAxes: [
//           {
//             ticks: {
//               beginAtZero: true
//             }
//           }
//         ]
//       }
//     }
//   });
// };
</script>

<style>
</style>